"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sax_1 = require("sax");

var xml_writer_1 = __importDefault(require("xml-writer"));

var parseAttributes = function parseAttributes(attributes) {
  return attributes;
};

exports.encode = function (project) {
  var xml = new xml_writer_1.default(true); // const writeAttributes = (attributes: { [key: string]: any }) => {
  //     Object.entries(attributes).forEach(([a, b]) => xml.writeAttribute(a, b))
  // };

  var elementTypeToName = function elementTypeToName(type) {
    switch (type) {
      case 'project':
        return 'SapelliCollectorProject';
      // Just capitalized version of name

      default:
        return type.charAt(0).toUpperCase() + type.slice(1);
    }
  };

  var writeElement = function writeElement(node) {
    xml.startElement(elementTypeToName(node.type));
    Object.entries(node.attributes).forEach(function (_a) {
      var a = _a[0],
          b = _a[1];

      if (b && typeof b.toString === 'function') {
        xml.writeAttribute(a, b.toString());
      }
    });
    node.children.forEach(writeElement);
    xml.endElement();
  };

  xml.startDocument('1.0', 'UTF-8');
  writeElement(project);
  xml.endDocument();
  console.log('HERE', xml.toString());
  return xml.toString();
};

exports.decode = function (xml) {
  if (!xml) {
    throw Error('Invalid XML');
  }

  var xmlParser = sax_1.parser(true);
  var currentNode;
  var depth = 0;

  xmlParser.onopentag = function (node) {
    switch (node.name) {
      case 'SapelliCollectorProject':
        {
          if (currentNode) {
            throw Error('Only one project is allowed');
          }

          var project = {
            type: 'project',
            images: null,
            sounds: null,
            attributes: parseAttributes(node.attributes),
            parent: undefined,
            depth: depth,
            children: []
          };
          currentNode = project;
          break;
        }

      case 'Form':
        {
          if (currentNode.type !== 'project') {
            throw Error('Form must be child of project');
          }

          var form = {
            type: 'form',
            attributes: parseAttributes(node.attributes),
            parent: currentNode,
            depth: depth,
            children: []
          }; // Push the form to the project

          currentNode.children.push(form);
          currentNode = form;
          break;
        }

      default:
        {
          // console.warn('Unknown field', node);
          var field = {
            type: node.name.toLowerCase(),
            attributes: node.attributes,
            parent: currentNode,
            depth: depth,
            children: []
          };
          currentNode.children.push(field);
          currentNode = field;
          break;
        }
    }

    depth++;
  };

  xmlParser.onclosetag = function () {
    if (currentNode.parent !== undefined) {
      currentNode = currentNode.parent;
    }

    depth--;
  };

  return new Promise(function (resolve, reject) {
    xmlParser.onend = function () {
      resolve(currentNode);
    };

    xmlParser.onerror = reject;
    xmlParser.write(xml).close();
  });
};